
// const BASE_URL = "http://165.232.103.247:9900"
// export const IMG_URL = "http://165.232.103.247:9900/"
const BASE_URL = "https://app.fittomo.com:9900";
export const IMG_URL = "https://app.fittomo.com:9900/";

export const LOGIN_API = BASE_URL + "/auth/login";
export const CHANGE_PASSWORD = BASE_URL + "/auth/changePassword";

// Dashboard
export const DASHBOARD = BASE_URL + "/admin/dashboard";

// Users
export const USER_LIST = BASE_URL + "/admin/user_list";
export const BLOCK_USER_LIST = BASE_URL + "/admin/get_all_blocked_user";
export const USER_DELETE = BASE_URL + "/admin/delete_user";
export const USER_BLOCK_UNBLOCK = BASE_URL + "/admin/block_unblock";
export const GET_USER_POST = BASE_URL + "/admin/user_all_post";
export const USER_DETAILS = BASE_URL + "/admin/user_detail";

// All post
export const GET_POST_ALL = BASE_URL + "/admin/post_list";
export const DELETE_POST  = BASE_URL + "/admin/delete_post";

// Logout 
export const LOGOUT_API = BASE_URL + "/auth/logOut";

// Excercise
export const EXPERCISE_LIST = BASE_URL + "/admin/excercise_list";
export const ADD_EXPERCISE = BASE_URL + "/user/addExcercise";
export const EDIT_EXPERCISE = BASE_URL + "/admin/editExcercise";
export const DELETE_EXPERCISE = BASE_URL + "/admin/deleteExcercise";

// Report 
export const REPORT_LIST = BASE_URL + "/admin/get_reported_users_list";
export const REPORT_DETAILS = BASE_URL + "/admin/get_reported_user_detail";

//Notification
export const ALL_NOTIFICATION_USER = BASE_URL + "/admin/notification_users";
export const SEND_NOTIFICATION = BASE_URL + "/admin/send_notification";
